<template>
  <div>
    <div v-if="isTable" flexContainer class="orgTable">
      <div class="table_org" flex-1 flexContainer>
        <div class="search_line" flexContainer>
          <span class="title_num">累计组织 {{ org_num }} 个</span>
          <div class="search_a" flexContainer>
            <div class="search_date">
              <span>日期范围：</span>
              <el-date-picker
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                v-model="value_date"
                placeholder="选择日期"
                @change="table_info"
              ></el-date-picker>
            </div>
            <div class="search_input">
              <el-input
                v-model="search_val"
                clearable
                placeholder="搜索"
                @clear="go_back"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
              <el-button @click="table_info">搜索</el-button>
            </div>
          </div>
        </div>
        <div class="table_line" flex-1>
          <el-table
            :data="tableData"
            :height="real_height + 'px'"
            :width="real_width"
            :header-cell-style="headerClass"
            :row-class-name="class_name"
            @sort-change="change_table"
          >
            <el-table-column label="编号" min-width="60">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 + (page - 1) * pageSize }}</span>
              </template>
            </el-table-column>
            <el-table-column label="组织名称" width="180">
              <template slot-scope="scope">
                <el-popover
                  ref="popover"
                  placement="top"
                  width="200"
                  trigger="hover"
                  :content="scope.row.name"
                >
                  <span slot="reference" class="org_name_show">{{
                    scope.row.name
                  }}</span>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              prop="createName"
              label="负责人"
              min-width="180"
            ></el-table-column>
            <el-table-column
              prop="contactsPhone"
              label="负责人手机号"
              width="130"
            ></el-table-column>
            <el-table-column
              prop="scale"
              label="组织规模"
              min-width="130"
            ></el-table-column>
            <el-table-column
              prop="createTime"
              label="组织创建时间"
              sortable="column"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="createArea"
              label="创建地点"
              min-width="160"
            ></el-table-column>
            <!-- <el-table-column
            prop="6"
            label="组织标签"
            width="220"
            :filters="[{text: '认证', value: 'ren'}, {text: '付费', value: 'fu'}, {text: '活跃', value: 'huo'}]"
            :filter-method="filterHandler"
          >
            <template>
              <div class="tabs_block">
                <div class="tabs_org">认证</div>
                <div class="tabs_org">付费</div>
                <div class="tabs_org">活跃</div>
              </div>
            </template>
            </el-table-column>-->
            <el-table-column
              prop="org_address"
              label="操作"
              width="100"
              fixed="right"
            >
              <template slot-scope="scope">
                <span class="show_detail" @click="openDetails(scope.row, scope)"
                  >查看详情</span
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <detail ref="detail_ref"></detail>
      </div>
      <div class="page_line">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page.sync="page"
          :page-size="pageSize"
          @current-change="table_info"
          :total="totalPage"
        ></el-pagination>
      </div>
    </div>
    <orgDetail :msg_obj="msg_obj" v-else></orgDetail>
  </div>
</template>
<script>
import { org_table, org_data } from "../../api/orgnazition";
import app from "../../mixin/index";
import { mapState } from "vuex";
export default {
  mixins: [app],
  components: {
    orgDetail: () => import(/* webpackChunkName: "design" */ "./detail"),
    detail: () =>
      import(/* webpackChunkName: "design" */ "./components/detail"),
  },
  data() {
    return {
      value_date: "",
      // isTable:-1,
      start: "",
      end: "",
      page: 1,
      sort: "",
      pageSize: 50,
      totalPage: "",
      search_val: "",
      org_height: document.documentElement.clientHeight,
      real_height: document.documentElement.clientHeight - 238,
      timer: false,
      org_num: "",
      tableData: [],
      msg_obj: {},
    };
  },

  mounted() {
    this.real_height = this.org_height - 238;
    const that = this;
    window.addEventListener("resize", function () {
      that.org_height = document.documentElement.clientHeight;
    });
    that.table_info();
  },
  watch: {
    org_height(val) {
      if (!this.timer) {
        this.real_height = val - 238;
        this.timer = true;
        let that = this;
        setTimeout(function () {
          that.timer = false;
        }, 400);
      }
    },
  },
  methods: {
    //筛选组织标签的方法 还没写完
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    //更改排序
    change_table(column, row) {
      if (column.order == "ascending") {
        this.sort = "asc";
      } else {
        this.sort = "";
      }
      this.table_info();
    },
    //清空搜索框调用方法
    go_back() {
      this.table_info();
    },
    //表格数据
    table_info() {
      if (this.value_date) {
        var day_pre = new Date(this.value_date[0]);
        var day_aft = new Date(this.value_date[1]);
        this.start = this.formateDate(day_pre);
        this.end = this.formateDate(day_aft);
      } else if (this.value_date == null || this.value_date == "") {
        this.start = "";
        this.end = "";
      }
      let data = {
        condition: this.search_val,
        startTime: this.start,
        endTime: this.end,
        page: this.page,
        size: this.pageSize,
        sort: this.sort,
      };
      let that = this;
      org_table(data)
        .then((res) => {
          //组织列表后台返回的字段是按123456顺序显示的
          that.tableData = res.data.organization;
          that.org_num = res.data.amount;
          that.totalPage = res.data.amount;
        })
        .catch((error) => {});
    },
    openDetails(row, a) {
      console.log(row.id);
      this.$store.state.isTable = false;
      this.$store.state.com_id = row.id;
      let data = {
        companyId: row.id,
      };
      org_data(data)
        .then((res) => {
          this.msg_obj = res.data;
          this.msg_obj.phone = row.contactsPhone;
          this.msg_obj.user = row.createName;
        })
        .catch((error) => {});
    },
  },
  computed: mapState(["isTable", "com_id"]),
};
</script>
<style lang="scss" scoped>
/deep/.colorLine {
  background-color: #fafcff !important;
}
/deep/.popularLine {
  background-color: #fff !important;
}
@include table;
</style>
